import eachElement from 'Utils/eachElement.js';

document.addEventListener('DOMContentLoaded', () => {
	eachElement('.backup-card', backupCard => {
		const now = new Date();
		now.setDate(now.getDate() + 1);
		now.setHours(0, 0, 0, 0);

		const options = {
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			hour12: true,
		};

		const formattedDate = now.toLocaleString('en-US', options);

		const timeElement = backupCard.querySelector('.backup-card-time');
		if (timeElement) {
			timeElement.innerHTML = formattedDate;
		}
	});
});
